module.exports = __webpack_public_path__ + "img/loss_rebate.ee5a2f26.png";